<form [formGroup]="Form"
      (ngSubmit)="onSubmit()">
  <mat-card class="card"
            [ngClass]="{'no' : isPopup}">

    <div fxLayout="row wrap"
         fxLayoutAlign="space-between center"
         fxLayoutGap="15px"
         class="top-heading text-bolder text-color" (click)="check()">
      Booking Details

      <button mat-button class="editBtn" (click)="goToEdit()" *ngIf="type == 'view' && editPermit && !isMultipleConditionTrue()">
        <mat-icon class="editIcon">edit</mat-icon>
        Edit
      </button>
    </div>
    <!-- <div *ngIf="isPopup" class="top-heading text-bold " style="margin-left: 10px;">
      {{childName}}, {{ageYear}} yrs {{ageMonth}} Month(s)
    </div> -->

    <div fxLayout="row wrap"
         fxLayoutAlign="space-between center"
         fxLayoutGap="15px"
         class="top-heading text-bold "
         style="margin-top: 13px">
         <div fxFlex>
          {{childName}}
         </div>
         <div fxFlex>
          <div style="display: flex; gap: 15px; place-content: end;font-weight: 600;">
            <div class="inline">
              <div class="tool">
                <button style="pointer-events: none;" mat-button class="btn-custom-form">
                  {{ ageYear }} yrs {{ ageMonth }} months
                  <mat-icon class="editIcon">info</mat-icon>
                </button>
                <div style="display:none" class="showToolTip">
                  {{ ageYear + 1 }} yrs - {{ futureDate1 }} <br>
                  {{ ageYear + 2 }} yrs - {{ futureDate2 }}
                </div>
              </div>
            </div>
         </div>
         </div>

    </div>
    <ng-container [formGroup]="childBookingDetail">

      <div *ngIf="bookingType == 'multiple_sessions'"
           fxLayout="row wrap"
           fxLayoutAlign="start center"
           fxLayoutGap="10px"
           class="row-wrap-margins">
          <div fxFlex.xl="30"
              fxFlex.lg="30"
              fxFlex.md="45"
              fxFlex.sm="45"
              fxFlex.xs="100"
              class="col-flex-margins">
                <mat-form-field>
                  <mat-label>Branch</mat-label>
                  <input matInput
                        readonly
                        type="text"
                        readonly
                        formControlName="branchName"
                        required>
                  <!-- <mat-error *ngIf="getField('id')">{{getErrorMessage('id')}}</mat-error> -->
                </mat-form-field>
          </div>
          <div fxFlex.xl="30"
              fxFlex.lg="30"
              fxFlex.md="45"
              fxFlex.sm="45"
              fxFlex.xs="100"
              class="col-flex-margins">
              <mat-form-field>
                <mat-label>Validity Type</mat-label>
                <mat-select class="height-40"
                            required
                            [disabled]="validityDisable"
                            (ngModelChange)="onValidityChange()"
                            formControlName="validityType">
                  <mat-option value="termOnly">Term-Time Only</mat-option>
                  <mat-option value="nonTerm">Non Term Time</mat-option>
                  <mat-option value="fullYear">All Year</mat-option>
                </mat-select>
              </mat-form-field>
          </div>
      </div>

      <ng-container *ngIf="bookingType !== 'multiple_sessions'">
          <div fxLayout="row wrap"
              fxLayoutAlign="space-between center"
              class="row-wrap-margins">

            <div fxFlex.xl="49"
                  fxFlex.lg="49"
                  fxFlex.md="45"
                  fxFlex.sm="45"
                  fxFlex.xs="100"
                  class="col-flex-margins">
              <mat-form-field>
                <mat-label>Branch</mat-label>
                <input matInput
                        readonly
                        type="text"
                        readonly
                        formControlName="branchName"
                        required>
                <!-- <mat-error *ngIf="getField('id')">{{getErrorMessage('id')}}</mat-error> -->
              </mat-form-field>
            </div>
            <div fxFlex.xl="49"
                  fxFlex.lg="49"
                  fxFlex.md="45"
                  fxFlex.sm="45"
                  fxFlex.xs="100"
                  class="col-flex-margins">
              <mat-form-field>
                <mat-label>Select Room</mat-label>
                <mat-select class="height-40"
                            required
                            formControlName="roomId"
                            (selectionChange)="onRoomChange($event)" [disabled]="isAttendancePopup">
                  <mat-option *ngFor="let option of rooms"
                              [value]="option?.value">
                    {{option?.label}} ({{option?.ageLabel}})
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

          </div>
          <div fxLayout="row wrap"
              fxLayoutAlign="start center"
              class="row-wrap-margins" fxLayoutGap="10px">

            <div fxFlex.xl="28"
                  fxFlex.lg="32"
                  fxFlex.md="45"
                  fxFlex.sm="45"
                  fxFlex.xs="100"
                  class="col-flex-margins">
              <mat-form-field>
                <mat-label>Validity Type</mat-label>
                <mat-select class="height-40"
                            required
                            (ngModelChange)="onValidityChange()"
                            [disabled]="validityDisable"
                            formControlName="validityType">
                  <mat-option value="termOnly">Term-Time Only</mat-option>
                  <mat-option value="nonTerm">Non Term Time</mat-option>
                  <mat-option value="fullYear">All Year</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div fxFlex.xl="28"
                  fxFlex.lg="32"
                  fxFlex.md="45"
                  fxFlex.sm="45"
                  fxFlex.xs="100"
                  class="col-flex-margins">
              <mat-form-field (click)="desired.open()">
                <mat-label style="margin-left: 7px;"> {{ bookingType == 'recurring_sessions' ? 'Start Date' : 'Date' }} </mat-label>
                <input matInput
                        style="margin-left: 10px;"
                        [min]="minStart"
                        [max]="maxStartDate"
                        required
                        (dateChange)="dateChangeStatic(childBookingDetail, 'joiningDate', $event)"
                        formControlName="matjoiningDate"
                        [matDatepickerFilter]="weekendFilter"
                        [matDatepicker]="desired">
                <mat-icon matPrefix>
                <img [src]="calendar"
                    style="margin-bottom: 4px; width: 16px; vertical-align: baseline;
                              cursor: pointer;">
                </mat-icon>
                <mat-icon *ngIf="hasValue('joiningDate')" matSuffix
                          class="closeIcon cp"
                          (click)="clearDate('joiningDate')">
                  close
                </mat-icon>
                <mat-datepicker #desired></mat-datepicker>
              </mat-form-field>
            </div>
            <div *ngIf="showLeaveDateCondition()" fxFlex.xl="28"
                  fxFlex.lg="32"
                  fxFlex.md="45"
                  fxFlex.sm="45"
                  fxFlex.xs="100"
                  class="col-flex-margins">
              <mat-form-field (click)="desired1.open()">
                <mat-label style="margin-left: 7px;"> Leave </mat-label>
                <input matInput
                        style="margin-left: 10px;"
                        [disabled]="isDateDisabled"
                        (dateChange)="dateChangeStatic(childBookingDetail, 'leavingDate', $event)"
                        [min]="minDate"
                        formControlName="matleaveDate"
                        [matDatepickerFilter]="weekendFilter"
                        [matDatepicker]="desired1">
                  <!-- <mat-icon style="position: absolute;
                  left: -9px;
                  bottom: 7px;" matPrefix (click)="desired1.open()">
                    <img  [src]="calendar"
                    style="margin-bottom: 4px;
                              width: 16px; vertical-align: baseline;
                              cursor: pointer;">
                  </mat-icon> -->

                  <mat-icon matPrefix>
                    <img  [src]="calendar"
                    style="margin-bottom: 4px;
                              width: 16px; vertical-align: baseline;
                              cursor: pointer;">
                  </mat-icon>

                <mat-icon *ngIf="hasValue('leavingDate')" matSuffix
                          class="closeIcon cp"
                          (click)="clearDate('leavingDate')">
                  close
                </mat-icon>
                <mat-datepicker #desired1></mat-datepicker>
              </mat-form-field>
            </div>

          </div>
      </ng-container>

        <!-- <div fxFlex.xl="28"
             fxFlex.lg="32"
             fxFlex.md="45"
             fxFlex.sm="45"
             fxFlex.xs="100"
             class="col-flex-margins">
        </div> -->

      <div *ngIf="bookingType == 'recurring_sessions' && childBookingDetail.get('joiningDate').value">
        <mat-checkbox style="margin-left: 10px;" (ngModelChange)="onFrequencyChange()" formControlName="changeFrequency">
          Change Frequency</mat-checkbox>
      </div>

      <ng-container *ngIf="childBookingDetail.get('changeFrequency').value && bookingType == 'recurring_sessions'">
        <div class="row-wrap-margins">
          <strong> Repeat Every</strong>
        </div>

        <div fxLayout="row wrap" class="row-wrap-margins mt-20" fxLayoutAlign="start center" fxLayoutGap="10px">
          <div fxFlex="30">
            <mat-form-field>
              <mat-label>Repeat Period</mat-label>
              <input matInput
                     type="number"
                     min="1"
                     step="1"
                     max="99"
                     oninput="this.value = this.value == 0 ? null : this.value > 99 ? event.preventDefault() : Math.round(this.value)"
                     pattern="[1-9][0-9]{0,1}"
                     formControlName="repeatEvery"
                     required>
              <!-- <mat-error *ngIf="getField('id')">{{getErrorMessage('id')}}</mat-error> -->
            </mat-form-field>
          </div>
          <div fxFlex="30">
            <mat-form-field>
              <mat-label>Repeat Every</mat-label>
              <mat-select class="height-40"
                          required
                          formControlName="repeatPeriod">
                <mat-option value="week">Week</mat-option>
                <mat-option value="month">Month</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div fxFlex="35" *ngIf="childBookingDetail.get('repeatPeriod').value && childBookingDetail.get('repeatEvery').value">
             <p class="info">Occurs every {{ getNumberWithSuffix() }}
                <span> {{ childBookingDetail.get('repeatPeriod').value }} </span>
                <span *ngIf="childBookingDetail.get('leavingDate').value">
                  until {{ childBookingDetail.get('leavingDate').value | date: 'dd/MM/yyyy' }}
                </span>
             </p>
          </div>
        </div>
      </ng-container>


    </ng-container>

    <div *ngIf="bookingType != 'multiple_sessions'"
        fxLayout="row wrap"
        fxLayoutAlign="space-between center"
        fxLayoutGap="15px"
        class="top-heading text-bolder text-color mb-20">
        <div>
          Session Details
        </div>
        <div>
          <button
          style="background-color: rgb(226, 175, 42);"
          class="header-button approve"
          type="button"
          [disabled]="!childBookingDetail.get('joiningDate').value || isAllSessionEmpty()"
          (click)="openAdvanceSettingsDialog()"
          mat-raised-button>Advanced Settings</button>
        </div>
   </div>

    <!-- Select Single Session -->

    <div *ngIf="bookingType == 'adhoc_session'" fxLayout="row wrap" fxLayoutAlign="start center">
      <div fxFlex="68" fxFlex.md="65">
          <ng-container formArrayName="sessionDetail"
          *ngFor="let session of sessionDetail.controls; let i = index;">
            <ng-container [formGroupName]="i" >
            <div *ngIf="bookingType == 'adhoc_session'" fxLayout="row wrap"
                fxLayoutAlign="space-between center"
                class="row-wrap-margins">
              <div fxFlex.xl="22"
                  fxFlex.lg="22"
                  fxFlex.md="22"
                  fxFlex.sm="22"
                  fxFlex.xs="100"
                  class="col-flex-margins">

                  <div [ngStyle]="session.controls['disable'].value === true ? {'background-color': 'white', 'color': '#00AFBB', 'border': '1px solid #00AFBB'} : {'background-color': '#00AFBB'}"
                        class="day-name">
                    <p style="text-transform: capitalize; line-height: 42px;">{{session.controls['day'].value | titlecase }}</p>
                    </div>
              </div>
              <div fxFlex.xl="22"
                  fxFlex.lg="22"
                  fxFlex.md="22"
                  fxFlex.sm="22"
                  fxFlex.xs="100"
                  class="col-flex-margins"
                  [ngStyle]="{ 'margin-top.px': isAttendancePopup && useCustomeMargin ? -8 : 10 }">
                  <mat-form-field>
                    <mat-label><span style="color: red">*</span> Select Session</mat-label>
                    <mat-select (selectionChange)="onSessionChange($event, session)"
                                required
                                formControlName="sessionId">
                      <mat-option *ngFor="let option of sessions"
                                  [value]="option?.id">
                        {{option?.name}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
              </div>
              <div fxFlex.xl="22"
                  fxFlex.lg="22"
                  fxFlex.md="22"
                  fxFlex.sm="22"
                  fxFlex.xs="100"
                  style="margin-bottom: 20px;"
                  class="col-flex-margins">
                  <!-- [min]="session.controls['matStartTime'].value"
                  [max]="session.controls['matEndTime'].value" -->
                  <timepicker controlName="startTime"
                              (onSetTime)="onSetTime($event, session)"
                              [disabled]="session.controls['disable'].value || session.controls['category'].value == 'standard' || session.controls['category'].value == null"
                              [time]="session.controls['matStartTime'].value"
                              [startTime]="session.controls['matStartTime'].value"
                              [endTime]="session.controls['matEndTime'].value"
                              [showError]="session.controls['matStartTime'].invalid"
                              [required]="true"
                              [screen]="'booking'"
                              [isStartEnd]="true"
                              label="Start"></timepicker>
                  <!-- <timepicker controlName="startTime"
                              (onSetTime)="onSetTime($event, session)"
                              [disabled]="session.controls['disable'].value || session.controls['category'].value == 'standard' || session.controls['category'].value == null"
                              [time]="session.controls['startTime'].value"
                              [max]="session.controls['endTime'].value"
                              [showError]="session.controls['startTime'].invalid"
                              [required]="true"
                              [screen]="'booking'"
                              label="Start"></timepicker> -->
              </div>
              <div fxFlex.xl="22"
                  fxFlex.lg="22"
                  fxFlex.md="22"
                  fxFlex.sm="22"
                  fxFlex.xs="100"
                  style="margin-bottom: 20px;"
                  class="col-flex-margins">
                  <timepicker controlName="endTime"
                              (onSetTime)="onSetTime($event, session)"
                              [disabled]="session.controls['disable'].value || session.controls['category'].value == 'standard' || session.controls['category'].value == null"
                              [time]="session.controls['matEndTime'].value"
                              [startTime]="session.controls['matStartTime'].value"
                              [endTime]="session.controls['matEndTime'].value"
                              [min]="session.controls['matStartTime'].value"
                              [max]="session.controls['matEndTime'].value"
                              [showError]="session.controls['matEndTime'].invalid"
                              [required]="true"
                              [screen]="'booking'"
                              [isStartEnd]="true"
                              label="End"></timepicker>
                  <!-- <timepicker controlName="endTime"
                              (onSetTime)="onSetTime($event, session)"
                              [disabled]="session.controls['disable'].value || session.controls['category'].value == 'standard' || session.controls['category'].value == null"
                              [time]="session.controls['endTime'].value"
                              [min]="session.controls['startTime'].value"
                              [showError]="session.controls['endTime'].invalid"
                              [required]="true"
                              [screen]="'booking'"
                              label="End"></timepicker> -->
              </div>
              <!-- <div fxFlex.xl="35"
                  fxFlex.lg="35"
                  fxFlex.md="35"
                  fxFlex.sm="35"
                  fxFlex.xs="100"
                  class="col-flex-margins">

                  <mat-checkbox formControlName="overrideRecurring" style="margin-left: 10px;">
                    Overriding Recurring Session(s)</mat-checkbox>

              </div> -->
            </div>

            <div class="row-wrap-margins" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="10px">
              <div fxFlex="20">
                <div style="display: flex; cursor: pointer;"
                    *ngIf="session.controls['disable'].value !== true || session.controls['slots'].value.length > 0">
                <div class="hour-box"
                    [ngClass]="[i === 0 ? 'hour-box-start' : i === session.controls['slots'].value.length - 1 ? 'hour-box-end' : 'hour-box-mid',
              getOccupencyColor(slot)]"
                    *ngFor="let slot of session.controls['slots'].value, ; let i = index;"
                    [matTooltip]="getTooltip(slot)"></div>
                </div>

                <div style="display: flex; cursor: pointer;"
                      *ngIf="session.controls['disable'].value !== false && session.controls['slots'].value.length == 0">
                  <div class="hour-box hour-box-start hour-box-disabled"></div>
                  <div class="hour-box hour-box-mid hour-box-disabled"></div>
                  <div class="hour-box hour-box-mid hour-box-disabled"></div>
                  <div class="hour-box hour-box-mid hour-box-disabled"></div>
                  <div class="hour-box hour-box-mid hour-box-disabled"></div>
                  <div class="hour-box hour-box-mid hour-box-disabled"></div>
                  <div class="hour-box hour-box-mid hour-box-disabled"></div>
                  <div class="hour-box hour-box-mid hour-box-disabled"></div>
                  <div class="hour-box hour-box-mid hour-box-disabled"></div>
                  <div class="hour-box hour-box-mid hour-box-disabled"></div>
                  <div class="hour-box hour-box-end hour-box-disabled"></div>
                </div>
              </div>
            </div>
            </ng-container>

          </ng-container>
      </div>

      <div fxFlex="32" fxFlex.md="35">
        <mat-checkbox class="override" [(ngModel)]="overrideRecurring" [ngModelOptions]="{standalone: true}" (ngModelChange)="openOverrideRecurringDialog($event)" [disabled]="activeBookings.length == 0 || !childBookingDetail.get('joiningDate').value || isRecurringSessionsEmpty || type == 'view'" style="margin-left: 5px; margin-bottom: 5px;">
          Overriding Recurring Session(s)</mat-checkbox>
      </div>
    </div>


    <!-- End -->

    <!-- Recurring Session -->

    <div *ngIf="bookingType == 'recurring_sessions'" fxLayout="row wrap"
         fxLayoutAlign="start center"
         fxLayoutGap="15px"
         class="row-margin">
      <ng-container formArrayName="sessionDetail"
                    *ngFor="let session of sessionDetail.controls; let i = index;">
        <div fxFlex.xl="23"
             fxFlex.lg="18"
             fxFlex.md="45"
             fxFlex.sm="45"
             fxFlex.xs="100"
             [formGroupName]="i"
             style="border-right: 1px solid #E4E7E9; padding-right: 20px;">
          <!-- <button mat-button
                        class="btn-custom-day">Monday</button> -->
          <div [ngStyle]="session.controls['disable'].value === true ? {'background-color': 'white', 'color': '#00AFBB', 'border': '1px solid #00AFBB'} : {'background-color': '#00AFBB'}"
               class="day-name"
               (click)="selectDay(session)">
            <p style="text-transform: capitalize; line-height: 42px;">{{session.controls['day'].value}}</p>
          </div>

          <mat-form-field>
            <mat-label><span style="color: red">*</span> Select Session</mat-label>
            <mat-select (selectionChange)="onSessionChange($event, session)"
                        required
                        formControlName="sessionId">
              <mat-option *ngFor="let option of sessions"
                          [value]="option?.id">
                {{option?.name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <div style="margin: 0 0 25px 0;">
            <!-- [min]="session.controls['matStartTime'].value"
            [max]="session.controls['matEndTime'].value" -->
            <timepicker controlName="startTime"
                        (onSetTime)="onSetTime($event, session,i)"
                        [disabled]="session.controls['disable'].value || session.controls['category'].value == 'standard' || session.controls['category'].value == null"
                        [time]="session.controls['matStartTime'].value"
                        [startTime]="session.controls['matStartTime'].value"
                        [endTime]="session.controls['matEndTime'].value"
                        [showError]="session.controls['matStartTime'].invalid"
                        [required]="true"
                        [screen]="'booking'"
                        [isStartEnd]="true"
                        label="Start"></timepicker>
          </div>
          <div style="margin: 0 0 25px 0;">
            <timepicker controlName="endTime"
                        (onSetTime)="onSetTime($event, session,i)"
                        [disabled]="session.controls['disable'].value || session.controls['category'].value == 'standard' || session.controls['category'].value == null"
                        [time]="session.controls['matEndTime'].value"
                        [startTime]="session.controls['matStartTime'].value"
                        [endTime]="session.controls['matEndTime'].value"
                        [showError]="session.controls['matEndTime'].invalid"
                        [required]="true"
                        [screen]="'booking'"
                        [isStartEnd]="true"
                        label="End"></timepicker>
          </div>
          <!-- *ngIf="session.controls['day'].value !== 'friday'" -->
          <div style="display: flex; cursor: pointer;"
               *ngIf="session.controls['disable'].value !== true || session.controls['slots'].value.length > 0">
            <div class="hour-box"
                 [ngClass]="[i === 0 ? 'hour-box-start' : i === session.controls['slots'].value.length - 1 ? 'hour-box-end' : 'hour-box-mid',
            getOccupencyColor(slot)]"
                 *ngFor="let slot of session.controls['slots'].value, ; let i = index;"
                 [matTooltip]="getTooltip(slot)"></div>
          </div>

          <div style="display: flex; cursor: pointer;"
               *ngIf="session.controls['disable'].value !== false && session.controls['slots'].value.length == 0">
            <div class="hour-box hour-box-start hour-box-disabled"></div>
            <div class="hour-box hour-box-mid hour-box-disabled"></div>
            <div class="hour-box hour-box-mid hour-box-disabled"></div>
            <div class="hour-box hour-box-mid hour-box-disabled"></div>
            <div class="hour-box hour-box-mid hour-box-disabled"></div>
            <div class="hour-box hour-box-mid hour-box-disabled"></div>
            <div class="hour-box hour-box-mid hour-box-disabled"></div>
            <div class="hour-box hour-box-mid hour-box-disabled"></div>
            <div class="hour-box hour-box-mid hour-box-disabled"></div>
            <div class="hour-box hour-box-mid hour-box-disabled"></div>
            <div class="hour-box hour-box-end hour-box-disabled"></div>
          </div>
        </div>
      </ng-container>
    </div>

    <!-- End -->

    <!-- Multiple Session -->

      <app-multiple-booking-detail *ngIf="bookingType == 'multiple_sessions'"
                                   [formGroup]="Form"
                                   [mode]="type"
                                   (advanceDialog)="openAdvanceSettingsDialog()"
                                   [defaultRoomId]="childBookingDetail.get('roomId').value"
                                   [sessionDetailArr]="sessionDetail"></app-multiple-booking-detail>

    <!-- End -->

    <div *ngIf="bookingType !== 'multiple_sessions'" fxLayout="row wrap"
         fxLayoutAlign="space-between center"
         class="row-card-margins"
         style="margin-top: 2.5rem;">
      <div fxFlex="100"
           fxLayoutAlign="start start"
           class="row-wrap-margins">
        <div fxFlex="20" fxFlex.md="30" fxFlex.sm="35" fxFlex.xs="100"
             fxLayoutAlign="start start">
          <span style="background-color: #00D100; cursor:pointer;"
                class="slot-bar"></span>
          <span class="slot-bar-text">Available Slots</span>
        </div>
        <div fxFlex="25" fxFlex.md="30"  fxFlex.sm="35" fxFlex.xs="100"
             fxLayoutAlign="start start">
          <span style=" background-color: #FF9F10; cursor:pointer;"
                class="slot-bar"></span>
          <span class="slot-bar-text">Limited Slots Available</span>
        </div>
        <div fxFlex="25" fxFlex.md="30" fxFlex.sm="35" fxFlex.xs="100"
             fxLayoutAlign="start start">
          <span style="background-color: #F10000; cursor:pointer;"
                class="slot-bar"></span>
          <span class="slot-bar-text">No Available Slots</span>
        </div>
      </div>
    </div>
    <!-- <app-form-foooter (clearEvent)="clearForm()"
					  [footerProps]="footerProps"></app-form-foooter> -->

    <div fxLayout="row wrap"
         fxLayoutAlign="start start"
         fxLayoutGap="15px"
         class="row-margin">
      <!-- <div fxFlex="150px"
           *ngIf="footerProps.hasSubButton">
        <button (click)="onEndBooking()"
                type="button"
                mat-button
                class="btn-custom-form"
                style="background-color: #E2AF2A;"
                [style.background-color]="footerProps?.color">
          {{footerProps.subButtonLabel}}
        </button>
      </div> -->
      <!-- <div fxFlex="150px"
           *ngIf="!disableInput">
        <button (click)="onSubmit()"
                type="button"
                mat-button
                class="btn-custom-form">
          {{this.footerProps?.buttonLabel}}
        </button>
      </div>
      <div fxFlex="150px">
        <button *ngIf="!disableInput" type="button"
                mat-button
                class="btn-custom-form">
          Back
        </button>
      </div> -->


      <app-form-foooter *ngIf="type != 'view' && type != 'view-logs'"
                        (saveInfoEvent)="onSubmit()"
                        (backEvent)="goBack()"
                        (popUpCloseEvent)="closePopup()"
                        [footerProps]="footerProps"></app-form-foooter>
    </div>

    <mat-tab-group [selectedIndex]="tabIndex" (selectedTabChange)="setTabIndex($event.index,true)">
      <mat-tab label="Active Bookings Overview">
        <app-table-component [props]="tableConfigForActiveBooking"
                             height="auto"></app-table-component>
      </mat-tab>

      <mat-tab label="Fundings">
        <app-table-component [props]="tableConfigForFunding"
                             height="auto"></app-table-component>
      </mat-tab>
    </mat-tab-group>

  </mat-card>

</form>
